import React from 'react'
import AIQuizContext from '../../../contexts/AIQuizContext'
import StatusContext from '../../../contexts/StatusContext';
import {DisplayQuiz} from "./DisplayQuiz"

import { useLocation } from 'react-router-dom'
import { useEffect } from "react";
import {NavBarQuiz} from '../navbarquiz/NavBarQuiz'
import { AlertDialog } from '../alertdialog/AlertDialog'
import {Check, Cancel} from "@mui/icons-material"
import Stack from '@mui/material/Stack'
import {PushButton} from '../pushbutton/PushButton'
import {AvailableCredits} from '../availablecredits/AvailableCredits'
import {ScrollText} from "../scrolltext/ScrollText"
import { ProgressIcon } from '../customicons/ProgressIcon';
import AIButton from '../aibutton/AIButton';
import { DialogSelectModels } from '../aibutton/DialogSelectModels';

import "./aiquiz.css"

export const AIQuiz = () => {
   
    let {
        promptsandresponses, 
        onDeletePrompt,
        onCancelDelete,
        onAcceptDelete, 
        onClearChat,
        topic,
        setTopic,
        onNewQuestions,
        displaySample,
        onSubmitAnswer,
        onAcceptAnswer,
        onResetAnswer,
        setReset,
        reset,
        onResetQuiz,
       
        status
    } = React.useContext(AIQuizContext);

    let {
        isMobile,
        scrollRef,
        isLoading,
        changeLanguage,

        openDialog,
        openDialogBox,
        closeDialogBox,
        focusRef,

        //getAIModel,
        getAIProvider,
        getAIName,

        onClickAIButton,

    } = React.useContext(StatusContext);

    var  sample ='';
    const location = useLocation()
    if (location.state !== null)
         sample = location.state.sample

    useEffect(() => {
        const setSample = () => {
            
            if (sample)
            {
                displaySample(sample)
                //sample = ''
                location.state.sample = '';
            }
        }
        setSample();


    }, [sample, displaySample,location.state])

    const handleReset = () => {
        setReset(true)
    }
    const alertYes = () => {
        onClearChat()
        closeDialogBox()
    }

    const alertCancel = () => {
        closeDialogBox()
    }


  return (
    <div className="homeContainer">
     
      {
        isMobile() &&
         <AIButton pane={0} provider = {getAIProvider()} model = {getAIName()} onClick = {()=>{onClickAIButton(0)}}/>
      }
      
        <div>
            <NavBarQuiz title={changeLanguage('quiz', 'navbartitle')}/>
          

                <div className="response-markdown" ref = {scrollRef}>
                
                  
                        {
                            Array.isArray(promptsandresponses) &&
                            promptsandresponses.map((item) => (
                                <DisplayQuiz key= {item.id} displayprompt = {item} 
                                onCancelDelete = {onCancelDelete} onAcceptDelete= {onAcceptDelete} onDeletePrompt = {onDeletePrompt} onSubmitAnswer={onSubmitAnswer} onAcceptAnswer={onAcceptAnswer} onResetAnswer={onResetAnswer}/>
                                ))
                        }
                  
                </div> 
                <hr className = 'separator'></hr>
                
                <div className="flex-container" style={{width:isMobile() ? '100%' : '60%'}}>
                    <label style={{color:'rgb(59, 75, 93)', fontSize:'16px', fontWeight:'bold', paddingRight:'10px'}}>{changeLanguage('tutor','tutortema')}:</label>
                    <ScrollText text = {topic} rows={1} disabled={isLoading} onChange={(e) => setTopic(e.target.value)} />
                    <br></br>
                </div>
              
               
                <div ref = {focusRef} className="mainButtons">
                    <div style = {{width:'60%'}}>  
                       
                    <Stack direction="row" spacing={2}>
                        {
                            !isMobile() &&
                                <AIButton pane={0} provider = {getAIProvider()} model = {getAIName()} onClick = {()=>{onClickAIButton(0)}}/>
                        }
                        <PushButton onClick={openDialogBox} label =  {changeLanguage('tutor','clearall')}/>
                        {
                            (!reset)  ? 
                                <PushButton onClick={handleReset} label =  {changeLanguage('quiz','reset')}/>
                            : 
                            <>
                                <Cancel className="iconWithNoBackground"  onClick={() => {!isLoading && setReset(false) }} />
                                <Check className="iconWithNoBackground"  onClick={() => {!isLoading && onResetQuiz()}} />
                            </>

                        }
                         <PushButton onClick={onNewQuestions} label =  {changeLanguage('tutor','askquestion')}/>
                    </Stack>
                    </div> 

                    <AvailableCredits />
                
                </div> 
                            
               
                {
                (status) && <label className='statusLabel'>{status}</label>
              
                }

                <label style={{ width: isMobile ? '100%' : '50%' }}>{changeLanguage("quiz", "note")}</label>

                <AlertDialog alertYes={alertYes} alertCancel={alertCancel} openDialog = {openDialog} closeDialog = {closeDialogBox} prompt={changeLanguage('dialog', 'cleardata')}/>
                <ProgressIcon isLoading={isLoading} /> 
                <DialogSelectModels />
                
            </div>


     </div>   
  )
}


